import { uri } from '../../api-endpoint';
import { IKoumutenFromAPISuccessResponse } from '../../type-conversion/koumuten/from-api-repsonse';
import { fetchListTemplateFn } from '../common';

export const fetchKoumutenListAPI = (token: string) =>
  fetchListTemplateFn(
    token,
    uri.koumutenList(),
    IKoumutenFromAPISuccessResponse
  );
